import React from 'react';
import {
  Formik,
} from 'formik';
import {
  toast,
} from 'react-toastify';

import {
  Flex,
  Text,
} from 'web-styled';
import {
  Button,
  ThreeFolders,
} from 'web-components';

type Props = {
  helper: string,
  buttonText: string,
  folderName: string,
  onSubmit: { (data: any, actions: any): void };
};

const Body = ({
  helper,
  buttonText,
  folderName,
  onSubmit,
}: Props) => (
  <Formik
    initialValues={{}}
    onSubmit={onSubmit}
  >
    {({
      values,
      isSubmitting,
      submitForm,
      handleSubmit,
      setFieldValue,
    }) => (
      <Flex
        column
        as="form"
        width="100%"
        spacing={15}
        onSubmit={handleSubmit}
      >
        <Text
          size="15px"
          color="#9f9f9f"
        >
          {helper}
        </Text>
        <hr />
        <ThreeFolders
          selectedId={values.folderId}
          folderName={folderName}
          onSelect={(id) => {
            setFieldValue('folderId', id);
          }}
        />
        <hr />
        <Flex width="100%" justify="flex-end">
          <Button
            ghost
            spacing="large"
            appearance="primary"
            isLoading={isSubmitting}
            isDisabled={isSubmitting}
            onClick={() => {
              if (values.folderId) {
                submitForm();
              } else {
                toast.error('No item was selected');
              }
            }}
          >
            {buttonText}
          </Button>
        </Flex>
      </Flex>
    )}
  </Formik>
);

export default Body;
